import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import InputMask from "react-input-mask";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { CustomService } from "../../../services/api/custom/CustomService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import "./styles.scss";

function RegisterColaboratorForm({ userId }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const onSubmit = async (data) => {
    try {
      const formattedData = {
        ...data,
        cpf: data.cpf.replace(/\D/g, ""), // Remove todos os caracteres não numéricos
      };

      await CustomService.postRequest("/interno/colaborador", formattedData);
      toast.success("Colaborador cadastrado com sucesso!");
      navigate(`/colaboradores`);
    } catch (error) {
      toast.error("Erro ao cadastrar colaborador.");
    }
  };

  useEffect(() => {
    if (userId) {
      console.log(userId);
      // Buscar colaborador pelo id
    }
  }, [userId]);

  return (
    <div className="flex flex-col w-full gap-3">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-wrap gap-3 w-full">
        {/* Input de nome */}
        <div className="w-full md:w-[48.9%]">
          <label className="block mb-1">Nome:</label>
          <input
            type="text"
            className="border border-gray-300 p-2 w-full"
            {...register("nome", { required: "O nome é obrigatório" })}
          />
          {errors.nome && <p className="text-red-500 text-sm">{errors.nome.message}</p>}
        </div>
        {/* Input de email */}
        <div className="w-full md:w-[48.9%]">
          <label className="block mb-1">Email:</label>
          <input
            type="email"
            className="border border-gray-300 p-2 w-full"
            {...register("email", {
              required: "O email é obrigatório",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Formato de email inválido",
              },
            })}
          />
          {errors.email && <p className="text-red-500 text-sm">{errors.email.message}</p>}
        </div>

        {/* Input de CPF com máscara */}
        <div className="w-full md:w-[48.9%]">
          <label className="block mb-1">CPF:</label>
          <InputMask
            mask="999.999.999-99"
            {...register("cpf", {
              required: "O CPF é obrigatório",
              validate: (value) => {
                const unmaskedValue = value.replace(/\D/g, "");
                return unmaskedValue.length === 11 || "O CPF deve ter 11 dígitos";
              },
            })}
          >
            {(inputProps) => <input type="text" className="border border-gray-300 p-2 w-full" {...inputProps} />}
          </InputMask>
          {errors.cpf && <p className="text-red-500 text-sm">{errors.cpf.message}</p>}
        </div>

        {/* Input de senha */}
        <div className="w-full md:w-[48.9%] relative">
          <label className="block mb-1">Senha:</label>
          <input
            type={showPassword ? "text" : "password"}
            className="border border-gray-300 p-2 w-full"
            {...register("senha", {
              required: "A senha é obrigatória",
              minLength: {
                value: 6,
                message: "A senha deve ter pelo menos 6 dígitos",
              },
            })}
          />
          <div
            className="absolute inset-y-0 right-0 pr-3 top-7 flex items-center cursor-pointer"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
          </div>
          {errors.senha && <p className="text-red-500 text-sm">{errors.senha.message}</p>}
        </div>

        {/* Botão de enviar */}
        <div className="w-full">
          <input
            type="submit"
            value="Cadastrar"
            className="bg-blue-default text-white p-2 mt-4 cursor-pointer text-[14px]"
          />
        </div>
      </form>
    </div>
  );
}

export default RegisterColaboratorForm;
